var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.854 108.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M19.585,0A19.585,19.585,0,1,1,0,19.585,19.584,19.584,0,0,1,19.585,0",
    transform: "translate(16.115 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M28.7,57.4a28.788,28.788,0,1,1,20.264-8.432A28.495,28.495,0,0,1,28.7,57.4ZM6.62,26.834a2.024,2.024,0,0,0-2,2A23.755,23.755,0,0,0,11.7,45.7a24.315,24.315,0,0,0,10.747,6.12,1.775,1.775,0,0,0,.426.052,2.064,2.064,0,0,0,2.022-1.821l.269-2.312A18.016,18.016,0,0,0,21.219,34.82l-.136-.136a18.589,18.589,0,0,0-9.929-6.666L7.208,26.93A1.849,1.849,0,0,0,6.62,26.834ZM50.659,26.6a2.17,2.17,0,0,0-.472.052l-3.809,1.088a18.6,18.6,0,0,0-9.929,6.666l-.136.136A18.653,18.653,0,0,0,32.372,47.6l.133,2.312a1.991,1.991,0,0,0,1.978,1.822,2.165,2.165,0,0,0,.47-.053,22.655,22.655,0,0,0,10.611-6.12,23.457,23.457,0,0,0,7.072-17,1.927,1.927,0,0,0-.6-1.423A2,2,0,0,0,50.659,26.6Zm-22-2.674q-.116,0-.234.005a4.7,4.7,0,0,0-4.487,4.491,4.787,4.787,0,0,0,4.793,5.038q.119,0,.239-.006a4.627,4.627,0,0,0,4.491-4.491,4.786,4.786,0,0,0-4.8-5.038ZM28.7,19.04a8.66,8.66,0,0,1,3.805.818,18.584,18.584,0,0,0,7.357,1.513,18.168,18.168,0,0,0,7.6-1.649l.951-.409a1.943,1.943,0,0,0,1-1.189,2.126,2.126,0,0,0-.178-1.665A23.6,23.6,0,0,0,41.892,8.7a22.239,22.239,0,0,0-8.708-3.536A25.988,25.988,0,0,0,28.852,4.8a23.913,23.913,0,0,0-17.02,7.031,19.613,19.613,0,0,0-3.672,4.627A2.05,2.05,0,0,0,8,18.007a2.149,2.149,0,0,0,.98,1.306l.951.409a18.169,18.169,0,0,0,7.6,1.649,18.582,18.582,0,0,0,7.357-1.513A9.052,9.052,0,0,1,28.7,19.04Z",
    transform: "translate(33.459 51.412)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M61.612,12.377A32.815,32.815,0,0,0,48.147,0,22.48,22.48,0,0,1,33.458,5.44,23.1,23.1,0,0,1,18.769.136,35.141,35.141,0,0,0,0,30.058V41.211c0,4.488,14.417,8.161,32.233,8.3a32.969,32.969,0,0,1-.68-6.392A30.657,30.657,0,0,1,61.612,12.377",
    transform: "translate(0 37.131)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/Driver.50a9d0ee18cdefe17540c59c010e9751.svg";
export { ForwardRef as ReactComponent };